import React, {Component} from 'react';
import {reduxForm, Field} from 'redux-form';
import {TextField} from 'redux-form-material-ui';
import Grid from 'material-ui/Grid';
import {Validator} from '../../core/Validator';

const validate = values => Validator.build(values, {
    'title': [Validator.required],
    'content': [Validator.required],
});

class NewsForm extends Component {
    render() {
        return (
            <div style={{padding: '16px 8px'}}>
                <form onSubmit={this.props.handleSubmit}>
                    <Grid container>
                        <Grid item md={12}>
                            <Field
                                name="title"
                                fullWidth={true}
                                component={TextField}
                                label="Titre de l'article"
                            />
                        </Grid>
                        <Grid item md={12}>
                            <Field
                                name="content"
                                multiline
                                fullWidth={true}
                                component={TextField}
                                label="Contenu de l'article"
                                rows={5}
                            />
                        </Grid>
                    </Grid>
                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'newsForm',
    validate
})(NewsForm);


// WEBPACK FOOTER //
// ./src/pages/home/NewsForm.js